import script from "./AddCommission.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCommission.vue?vue&type=script&setup=true&lang=js"

import "./AddCommission.vue?vue&type=style&index=0&id=9ebd1efa&lang=css"

export default script